import request from '@/utils/request'

export const stuGetAccessList = (params) => {
  return request.get('stuGetAccessList', {params})
}
export const stuGetRouteList = (params) => {
  return request.get('stuGetRouteList', {params})
}
export const zouduGetAttendancData = (params) => {
  return request.get('zouduGetAttendancData', {params})
}
export const zhuduGetAttendancData = (params) => {
  return request.get('zhuduGetAttendancData', {params})
}
export const fenceGetRouteData = (params) => {
  return request.get('fenceGetRouteData', {params})
}
export const stuGetTeacherBook = () => {
  return request.get('stuGetTeacherBook')
}
export const stuGetParentBook = (params) => {
  return request.get('stuGetParentBook', {params})
}
export const teacherPublishNotice = (data) => {
  return request.post('teacherPublishNotice', data)
}
export const dormGetSignData = (params) => {
  return request.get('dormGetSignData', {params})
}
